module.exports = __webpack_public_path__ + "static/media/openlite-js-white.ee741889.svg";